// extracted by mini-css-extract-plugin
module.exports = {"newsfeed":"Lu-z"};